import Mock from './mock';
import apolloClient from '../../utils/apollo-client';
import { hrGrantApplicationApproval as mutation } from '../graphql/approvals';
import { getEnv } from 'ecx.saigon.ui.common';

export default async function approvalDecision(uuid, payLoad) {
  const env = await getEnv();
  if (env.VUE_APP_USE_MOCK) {
    return Mock.data.hrApprovalCompletion;
  }

  const response = await apolloClient()
    .then((client) =>
      client.mutate({
        mutation,
        variables: {
          uuid,
          payLoad
        }
      })
    );

  return response.data.hrApprovalCompletion;
}
